var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1477_5596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "url(#paint0_linear_1477_5596)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4643 32.7679C21.2857 32.7679 25.1429 28.8393 25.1429 23.1607C25.1429 19.25 22.5179 16.375 18.0357 16.375C13.1786 16.375 9.375 20.3036 9.375 25.9821C9.375 29.9107 12.0536 32.7679 16.4643 32.7679ZM17.9464 19.6429C19.8393 19.6429 21.0536 21.0893 21.0536 23.3929C21.0536 26.7857 19.0714 29.5 16.5714 29.5C14.6786 29.5 13.4643 28.0357 13.4643 25.75C13.4643 22.375 15.4464 19.6429 17.9286 19.6429H17.9464ZM29.3393 16.6429L25.9821 32.5H30.0179L31 27.8571H33.625C37.9643 27.8571 40.7857 25.3929 40.7857 21.4286C40.7857 18.5536 38.6964 16.6429 35.25 16.6429H29.3571H29.3393ZM32.7321 19.75H34.4107C35.8929 19.75 36.7321 20.4286 36.7321 21.7857C36.7321 23.5714 35.5179 24.8214 33.625 24.8214H31.6429L32.7143 19.75H32.7321Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1477_5596",
    x1: 0,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1477_5596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimism);
export default __webpack_public_path__ + "static/media/optimism.554d002667634042e31e2ae3da741b5f.svg";
export { ForwardRef as ReactComponent };